(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mulilo-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mulilo-hero-slider')) {
    customElements.define('mulilo-hero-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (this.slides.length < 2) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.index = 0;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
        this.interval = Math.max(5000, Number(this.dataset.interval) || 7000);
        this.counter = this.querySelector('[data-counter]');
        this.status = this.querySelector('[data-status]');
        this.toggle = this.querySelector('[data-toggle]');
        this.tabs = [...this.querySelectorAll('[data-go]')];
        this.classList.add('is-enhanced');
        this.querySelector('[data-controls]').hidden = false;
        this.update();
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-toggle')) {
            this.paused = !this.paused;
            this.updateToggle();
            this.schedule();
          } else if (button.hasAttribute('data-previous')) this.go(this.index - 1, true);
          else if (button.hasAttribute('data-next')) this.go(this.index + 1, true);
          else if (button.hasAttribute('data-go')) this.go(Number(button.dataset.go), true);
        }, options);
        this.addEventListener('keydown', event => {
          if (!event.target.closest('[data-controls]')) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
          }
        }, options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; clearTimeout(this.timer); }
        }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', event => {
          clearTimeout(this.timer);
          if (!event.target.closest('[data-toggle]')) { this.paused = true; this.updateToggle(); }
        }, options);
        this.addEventListener('pointerdown', event => {
          if (event.pointerType === 'touch') this.startPoint = { x: event.clientX, y: event.clientY };
        }, options);
        this.addEventListener('pointerup', event => {
          if (!this.startPoint) return;
          const x = event.clientX - this.startPoint.x;
          const y = event.clientY - this.startPoint.y;
          this.startPoint = null;
          if (Math.abs(x) > 60 && Math.abs(x) > Math.abs(y) * 1.5) this.go(this.index + (x < 0 ? 1 : -1), true);
        }, options);
        this.addEventListener('pointercancel', () => { this.startPoint = null; }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.reduced.addEventListener('change', event => {
          if (event.matches) { this.paused = true; this.updateToggle(); }
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (index >= 0) this.go(index, true);
        }, options);
        this.schedule();
      }
      updateToggle() {
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.querySelector('[data-pause-icon]').hidden = this.paused;
        this.querySelector('[data-play-icon]').hidden = !this.paused;
      }
      update() {
        this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
        this.tabs.forEach((tab, index) => {
          if (index === this.index) tab.setAttribute('aria-current', 'true');
          else tab.removeAttribute('aria-current');
        });
        this.counter.textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.slides.length).padStart(2, '0')}`;
        this.updateToggle();
      }
      go(index, manual = false) {
        clearTimeout(this.timer);
        this.transition?.skipTransition();
        if (manual) this.paused = true;
        this.index = (index + this.slides.length) % this.slides.length;
        const render = () => this.update();
        if (manual && !this.reduced.matches && document.startViewTransition) this.transition = document.startViewTransition(render);
        else render();
        if (manual) this.status.textContent = this.slides[this.index].getAttribute('aria-label');
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || document.hidden) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.interval);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
